import * as actionTypes from "../actionTypes";
import axios from "../../middleware/axios-api";
import { getErrors, getResData } from "../../shared/utility";
import { LANGUAGES } from "../../constants/constants";

// ----------- Menu Option Controller ----------- //
export const setOpenMenu = () => {
  return {
    type: actionTypes.OPEN_HEADER_MENU,
  };
};

export const setCloseMenu = () => {
  return {
    type: actionTypes.CLOSE_HEADER_MENU,
  };
};

// ----------- Notification Modal Controller ----------- //
export const openNotificationModal = () => {
  return {
    type: actionTypes.OPEN_NOTIFICATION_MENU,
  };
};

export const closeNotificationModal = () => {
  return {
    type: actionTypes.CLOSE_NOTIFICATION_MENU,
  };
};

// ----------- Logout Modal Controller ----------- //
export const openLogoutModal = () => {
  return {
    type: actionTypes.OPEN_LOGOUT_MODAL,
  };
};

export const closeLogoutModal = () => {
  return {
    type: actionTypes.CLOSE_LOGOUT_MODAL,
  };
};

// ----------- Item Under Review Modal Controller ----------- //
export const openItemUnderReviewModal = () => {
  return {
    type: actionTypes.OPEN_ITEM_UNDER_REVIEW_MODAL,
  };
};

export const closeItemUnderReviewModal = () => {
  return {
    type: actionTypes.CLOSE_ITEM_UNDER_REVIEW_MODAL,
  };
};

// --------- Terms and condition Modal controller --------------//
export const setTermsConditionsModal = (state: boolean) => {
  return {
    type:actionTypes.TERMS_CONDITIONS_MODAL,
    state
  };
};

export const getTermsAndConditions = async (dispatch: any) => {
  try {
    dispatch({
      type: actionTypes.AUTH_TERMS_CONDITIONS_START,
    });
    const headers = {
      'Accept-Language': localStorage.getItem("i18nextLng") || LANGUAGES.AMHARIC.value,
    };
    const response = await axios.get(`/terms/and/conditions`, {headers});
    const data = getResData(response.data);

    if (!data.success) {
      throw new Error(getErrors(data));
    }

    dispatch({
      type: actionTypes.AUTH_TERMS_CONDITIONS_FINISH,
    });

    return data.data;
  } catch (err) {
    dispatch({
      type: actionTypes.AUTH_TERMS_CONDITIONS_FINISH,
    });

    throw new Error(getErrors(err));
  }
};

// --------- Privacy policy Modal controller --------------//
export const setPrivacyModal = (state: boolean) => {
  return {
    type:actionTypes.PRIVACY_POLICY_MODAL,
    state
  };
};

export const getPrivacyPolicy = async (dispatch: any) => {
  try {
    dispatch({
      type: actionTypes.AUTH_PRIVACY_POLICY_START,
    });
    const headers = {
      'Accept-Language': localStorage.getItem("i18nextLng") || LANGUAGES.AMHARIC.value,
    };
    const response = await axios.get(`/privacy/policy`, {headers});
    const data = getResData(response.data);

    if (!data.success) {
      throw new Error(getErrors(data));
    }

    dispatch({
      type: actionTypes.AUTH_PRIVACY_POLICY_FINISH,
    });

    return data.data;
  } catch (err) {
    dispatch({
      type: actionTypes.AUTH_PRIVACY_POLICY_FINISH,
    });

    throw new Error(getErrors(err));
  }
};

// Search text 
export const updateSearchText = (searchText: any) => {
  return {
    type: actionTypes.UPDATE_SEARCH_TEXT,
    searchText: searchText,
  }
}

// Delete notification modal control
export const openDeleteNotificationModal = (notificationId: number) => {
  return {
    type: actionTypes.OPEN_DELETE_NOTIFICATION_MODAL,
    id: notificationId, 
  }
}

export const closeDeleteNotificationModal = () => {
  return {
    type: actionTypes.CLOSE_DELETE_NOTIFICATION_MODAL,
  }
}

// Control delete advert modal
export const openDeleteAdvertModal = () => {
  return {
    type: actionTypes.OPEN_DELETE_ADVERT_MODAL,
  };
};
export const closeDeleteAdvertModal = () => {
  return {
    type: actionTypes.CLOSE_DELETE_ADVERT_MODAL,
  };
};

// Control delete chat modal
export const openDeleteChatModal = (title: string) => {
  return {
    type: actionTypes.OPEN_DELETE_CHAT_MODAL,
    title
  };
};
export const closeDeleteChatModal = () => {
  return {
    type: actionTypes.CLOSE_DELETE_CHAT_MODAL,
  };
};

// Control republish advert modal
export const openRepublishAdvertModal = () => {
  return {
    type: actionTypes.OPEN_REPUBLISH_ADVERT_MODAL,
  };
};
export const closeRepublishAdvertModal = () => {
  return {
    type: actionTypes.CLOSE_REPUBLISH_ADVERT_MODAL,
  };
};

// ----------- Switch user type Modal Controller ----------- //
export const openSwitchUserTypeModal = (navigateOnSuccess: any = null) => {
  return {
    type: actionTypes.OPEN_SWITCH_USER_TYPE_MODAL,
    navigateOnSuccess: navigateOnSuccess,
  };
};

export const closeSwitchUserTypeModal = () => {
  return {
    type: actionTypes.CLOSE_SWITCH_USER_TYPE_MODAL,
  };
};

export const setChangeProfileType = ( profile: string | null = null ) => {
  return {
    type: actionTypes.SET_CHANGE_PROFILE_TYPE,
    switchProfile: profile
  };
};

// ----------- Delete Account Modal Controller ----------- //
export const openDeleteAccountModal = () => {
  return {
    type: actionTypes.OPEN_DELETE_ACCOUNT_MODAL,
  };
};

export const closeDeleteAccountModal = () => {
  return {
    type: actionTypes.CLOSE_DELETE_ACCOUNT_MODAL,
  };
};

// ----------- Provider Service List Modal Controller ----------- //
export const toggleProviderServiceListModal = () => {
  return {
    type: actionTypes.TOGGLE_PROVIDER_SERVICE_MODAL,
  };
};

export const updateDataInProviderServiceListModal = (activeCategory: any) => {
  return {
    type: actionTypes.UPDATE_DATA_IN_PROVIDER_SERVICE_MODAL,
    activeCategory: activeCategory,
  };
};
